export { default as Icon, IconWrapper } from './Icon'
